import { useState } from "react";
import { Link } from "react-router-dom";

const REVIEWS = [
  {
    name: "Michael T.",
    location: "Fredericksburg, VA",
    text: "They removed a massive oak that was leaning dangerously close to our house. The crew showed up on time, worked efficiently, and cleaned everything up perfectly. Couldn't be happier — best tree service in Northern Virginia, without a doubt.",
    stars: 5,
    service: "Tree Removal",
    initial: "M",
    featured: true,
  },
  {
    name: "Sarah L.",
    location: "Stafford County, VA",
    text: "Very professional from start to finish. Trimmed 6 trees and the yard looks amazing. Fast, courteous, and very reasonable pricing. Will absolutely use them again.",
    stars: 5,
    service: "Tree Trimming",
    initial: "S",
    featured: false,
  },
  {
    name: "David K.",
    location: "Spotsylvania, VA",
    text: "Two stumps gone in under an hour. Great communication, honest pricing, and the yard looks fantastic now. Top-notch service all around.",
    stars: 5,
    service: "Stump Grinding",
    initial: "D",
    featured: false,
  },
  {
    name: "Jennifer R.",
    location: "King George, VA",
    text: "After a bad storm took out a tree on our fence line, Diversified was out the next day. True emergency response professionals. They handled everything seamlessly.",
    stars: 5,
    service: "Emergency Removal",
    initial: "J",
    featured: false,
  },
  {
    name: "Robert M.",
    location: "Culpeper, VA",
    text: "Free estimate was fast and accurate — no hidden fees. The crew was knowledgeable and even gave tips on our other trees. Best tree service I have used in 20 years.",
    stars: 5,
    service: "Tree Removal",
    initial: "R",
    featured: false,
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);
  const featured = REVIEWS[active];
  const others = REVIEWS.filter((_, i) => i !== active);

  return (
    <section className="py-24 bg-[#0f2018] relative overflow-hidden">
      {/* Subtle texture */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none"
        style={{ backgroundImage: "radial-gradient(circle at 20% 50%, #e8632a 0%, transparent 50%), radial-gradient(circle at 80% 20%, #fff 0%, transparent 40%)" }}
      />

      <div className="relative max-w-7xl mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <span className="text-[#e8632a] font-bold text-sm uppercase tracking-[3px] block mb-3">Real Reviews</span>
            <h2 className="text-4xl lg:text-5xl font-black text-white leading-tight">
              What Our Customers Say
            </h2>
            <div className="flex items-center gap-3 mt-4">
              <div className="flex gap-1">
                {[1,2,3,4,5].map((s) => <i key={s} className="ri-star-fill text-yellow-400 text-lg"></i>)}
              </div>
              <span className="text-white font-black text-lg">4.9</span>
              <span className="text-white/40 text-sm">/ 5 · 200+ Google Reviews</span>
            </div>
          </div>
          <Link
            to="/reviews"
            className="flex items-center gap-2 px-5 py-2.5 border border-white/20 text-white/70 text-sm font-bold rounded-xl hover:border-[#e8632a] hover:text-[#e8632a] transition-all cursor-pointer whitespace-nowrap"
          >
            Read All Reviews <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          {/* Featured review */}
          <div className="lg:col-span-3 bg-white rounded-3xl p-8 lg:p-10 flex flex-col justify-between">
            {/* Quote mark */}
            <div>
              <div className="text-[#e8632a] text-7xl font-black leading-none mb-4" style={{ fontFamily: "Georgia, serif" }}>&ldquo;</div>
              <p className="text-[#1e1e1e] text-xl lg:text-2xl font-medium leading-relaxed mb-8">
                {featured.text}
              </p>
            </div>
            <div className="flex items-center justify-between flex-wrap gap-4">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 flex items-center justify-center bg-[#e8632a] rounded-2xl font-black text-white text-xl flex-shrink-0">
                  {featured.initial}
                </div>
                <div>
                  <p className="font-black text-[#1e1e1e] text-lg">{featured.name}</p>
                  <p className="text-gray-400 text-sm">{featured.location}</p>
                </div>
              </div>
              <div className="flex flex-col items-end gap-1">
                <div className="flex gap-0.5">
                  {[...Array(featured.stars)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
                <span className="text-xs font-bold text-[#e8632a] bg-[#e8632a]/10 px-2 py-0.5 rounded-full">{featured.service}</span>
              </div>
            </div>
          </div>

          {/* Side reviews */}
          <div className="lg:col-span-2 flex flex-col gap-4">
            {others.slice(0, 4).map((r, i) => (
              <button
                key={r.name}
                onClick={() => setActive(REVIEWS.indexOf(r))}
                className="text-left bg-white/8 hover:bg-white/15 border border-white/10 rounded-2xl p-5 transition-all cursor-pointer group"
              >
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-9 h-9 flex items-center justify-center bg-[#e8632a] rounded-xl font-black text-white text-sm flex-shrink-0">
                    {r.initial}
                  </div>
                  <div>
                    <p className="text-white font-bold text-sm">{r.name}</p>
                    <p className="text-white/40 text-xs">{r.location}</p>
                  </div>
                  <div className="flex gap-0.5 ml-auto">
                    {[...Array(r.stars)].map((_, j) => (
                      <i key={j} className="ri-star-fill text-yellow-400 text-xs"></i>
                    ))}
                  </div>
                </div>
                <p className="text-white/60 text-xs leading-relaxed line-clamp-2 group-hover:text-white/80 transition-colors">
                  "{r.text}"
                </p>
              </button>
            ))}
          </div>
        </div>

        {/* Post-testimonial CTA */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 pt-8 border-t border-white/10">
          <p className="text-white/50 text-sm">Join 2,400+ satisfied customers across Northern Virginia</p>
          <Link
            to="/contact"
            className="flex items-center gap-2 px-6 py-3 bg-[#e8632a] text-white font-black rounded-xl uppercase tracking-wide hover:bg-[#d0541e] transition-all cursor-pointer whitespace-nowrap"
          >
            Get Your Free Estimate <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
